import base from "/mnt/data/b/monochrome/images/pause-large.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");